import { getUser } from 'services/local/auth';
import type { LocalStorageFunctions } from './types';
import type { ChoiceAsDefault } from 'pages/NewDocument/types';

const CHOICE_AS_DEFAULT: string = 'choice-as-default';

const getLocalStorageChoiceAsDefault = (fn: LocalStorageFunctions) => () => {
  const user = getUser(fn)();
  if (!user) return undefined;
  const choice = fn.readObject<Record<string, ChoiceAsDefault>>(CHOICE_AS_DEFAULT);
  if (!choice?.[user.user.email]) return undefined;
  return choice[user.user.email];
};

const setLocalStorageChoiceAsDefault = (fn: LocalStorageFunctions) => (data: ChoiceAsDefault) => {
  const user = getUser(fn)();
  if (!user) return;
  let choice = fn.readObject<Record<string, ChoiceAsDefault>>(CHOICE_AS_DEFAULT);
  if (!choice) {
    choice = {};
  }
  choice[user.user.email] = data;
  fn.writeObject(CHOICE_AS_DEFAULT, choice);
};

const delLocalStorageChoiceAsDefault = (fn: LocalStorageFunctions) => () => {
  const user = getUser(fn)();
  if (!user) return;
  const choice = fn.readObject<Record<string, ChoiceAsDefault>>(CHOICE_AS_DEFAULT);
  if (!choice?.[user.user.email]) return;
  delete choice[user.user.email];
  fn.writeObject(CHOICE_AS_DEFAULT, choice);
};

const choiceAsDefault = (fn: LocalStorageFunctions) => ({
  getLocalStorageChoiceAsDefault: getLocalStorageChoiceAsDefault(fn),
  setLocalStorageChoiceAsDefault: setLocalStorageChoiceAsDefault(fn),
  delLocalStorageChoiceAsDefault: delLocalStorageChoiceAsDefault(fn)
});

export default choiceAsDefault;
